import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Layout from '../layout';
import CampusManagers from '../components/CampusManagers/index.jsx';
import SEO from '../components/SEO/index';

class CampusManagersContainer extends Component {
	serializeCampusManagers = () => {
		let managers = [];
		this.props.data.allContentfulCampusManager.edges.map(edge => {
			managers.push({
				firstName: edge.node.firstName,
				lastName: edge.node.lastName,
				headshot: edge.node.headshot,
				university: edge.node.university.name,
				graduationYear: edge.node.graduationYear,
				phone: edge.node.phone,
				email: edge.node.email
			});
		});
		return managers;
	}

	render() {
		return (
			<Layout>
				<SEO 
					title="Campus Managers - Greek Dressing" 
					description="Dedicated entrepreneurs. Campus managers are the “go to” person for clients at their school. They hustle hard, and l(earn) a hell of a lot along the way." />
				<CampusManagers managers={this.serializeCampusManagers()}/>
			</Layout>
		)
	}
}

export default CampusManagersContainer

export const CMQuery = graphql`
	query {
		allContentfulCampusManager {
			edges {
				node {
					firstName
					lastName
					headshot {
						fluid(maxWidth: 300, maxHeight: 300) {
							...GatsbyContentfulFluid_withWebp
						}
					}
					university {
						name
					}
					graduationYear
					phone
					email   
				}
			}
		}
	}
`